import Route from '@ember/routing/route';

export default class HotelStrategyDowRoute extends Route {
  queryParams = {
    sortBy: {
      refreshModel: false,
    },
    sortDirection: {
      refreshModel: false,
    },
    tab: {
      refreshModel: false,
    },
  };
}
